import { defaultNextHiddenProviderIndex, maxNumberOfProvidersToShow } from './constants'
import { FeedbackType, ProviderLevelFeedbackSavePayload } from './types'
import { ProviderInfo } from '../../models/providers/Providers'

export const getSelectedWordChipsAsJoinedString = (wordChips?: string[]) => {
  return wordChips?.join(';').toLowerCase() ?? ''
}

export const getTrimmedFreeTextFeedback = (freeTextFeedback?: string) => {
  return freeTextFeedback?.trim() ?? ''
}

export const generateProviderLevelFeedbackSavePayload = ({
  userId,
  providerId,
  searchId,
  requestId,
  feedbackType,
  wordChips = [],
  freeTextFeedback = '',
}: {
  userId: string
  providerId: string
  searchId: string
  requestId: string
  feedbackType: FeedbackType
  wordChips: string[]
  freeTextFeedback: string
}): ProviderLevelFeedbackSavePayload => {
  const wordChipsString = getSelectedWordChipsAsJoinedString(wordChips)
  const trimmedFreeTextFeedback = getTrimmedFreeTextFeedback(freeTextFeedback)

  return {
    userLyraId: userId,
    providerLyraId: providerId,
    searchId,
    requestId,
    feedbackType,
    wordChips: wordChipsString,
    freeTextFeedback: trimmedFreeTextFeedback,
  }
}

export const getInitialNextHiddenProviderIndex = ({ totalNumberOfProviders }: { totalNumberOfProviders: number }) => {
  return totalNumberOfProviders > maxNumberOfProvidersToShow
    ? maxNumberOfProvidersToShow
    : defaultNextHiddenProviderIndex
}

export const getProvidersHidden = ({
  nextHiddenProviderIndex,
  providers,
}: {
  nextHiddenProviderIndex: number
  providers?: ProviderInfo[]
}) => {
  if (nextHiddenProviderIndex === defaultNextHiddenProviderIndex || !providers || providers.length === 0) {
    return []
  }

  // Get the lyra id and rank of the providers that are hidden and have an index greater than or
  // equal to the nextHiddenProviderIndex
  const providersHidden = providers.reduce<{ lyra_id: string; rank?: number }[]>((acc, provider, index) => {
    if (index >= nextHiddenProviderIndex && provider?.isVisible === false) {
      acc.push({ lyra_id: provider.lyra_id, rank: provider?.rank })
    }
    return acc
  }, [])

  return providersHidden
}

export const getProvidersVisible = ({ providers }: { providers?: ProviderInfo[] }) => {
  if (!providers || providers.length === 0) {
    return []
  }

  // Get the lyra id and rank of the providers that are visible
  const providersVisible = providers.reduce<{ lyra_id: string; rank?: number }[]>((acc, provider) => {
    if (provider?.isVisible) {
      acc.push({ lyra_id: provider.lyra_id, rank: provider?.rank })
    }
    return acc
  }, [])
  return providersVisible
}
